// Shared "diff two objects, return only the changed fields" logic — was
// previously copy-pasted identically (aside from which snapshot key to
// skip) across AddUser, AddGroup, and AddPerson.
export const diffChangedFields = (newObject, oldObject, excludeKeys = []) => {
  if (!oldObject) return undefined;

  return Object.keys(newObject).reduce((acc, key) => {
    if (excludeKeys.includes(key)) return acc;
    if (JSON.stringify(newObject[key]) !== JSON.stringify(oldObject[key])) {
      acc[key] = newObject[key];
    }
    return acc;
  }, {});
};
